<script lang="ts" setup>
import { TRACKING_EVENTS } from "@constant"
import { TrackingPlugin } from "@plugins/tracking.plugin"
import { useFormStore } from "@stores/form.store"
import { inject, onActivated, onDeactivated, ref } from "vue"

const { snapshot } = useFormStore()

const { $track } = inject<TrackingPlugin>("tracking")!

const timeCompletion = ref(new Date().getTime())

onActivated(() => {
    timeCompletion.value = new Date().getTime()
    $track(TRACKING_EVENTS.STEP_ENTERED, {
        step: snapshot.value.context.step + 1,
        formId: "",
    })
})

onDeactivated(() => {
    $track(TRACKING_EVENTS.STEP_COMPLETED, {
        step: snapshot.value.context.step + 1,
        timeCompletion: (
            (new Date().getTime() - timeCompletion.value) /
            1000
        ).toFixed(1),
    })
})
</script>

<template>
    <FormOptional />
</template>

<style scoped>
.form-sign-consent {
    &:deep(.p-card-content) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 3.5rem;

        padding-top: 3.5rem;
    }
}
</style>
